export default "__VITE_ASSET__BcLudLvJ__"